import { gql } from "@apollo/client";

/**
 * Compact set of guide fields used by list views and as the response shape
 * of summary mutations (archive / restore / delete). Keeping these in a
 * shared fragment guarantees that list rows hydrate the Apollo cache with
 * the same shape mutations write back, so optimistic UI stays consistent.
 */
export const INTERVIEW_GUIDE_HEADER_FIELDS = gql`
  fragment InterviewGuideHeaderFields on InterviewGuide {
    id
    title
    status
    archived
    author {
      id
      firstName
      lastName
    }
    division
    jobTitle
    questionsCount
    showSuggestions
    inputRequestedFrom {
      id
      firstName
      lastName
    }
    inUse
    updatedAt
  }
`;

/**
 * Full guide fields used by the editor and any view that needs every
 * question / checklist / competency entry.
 */
export const INTERVIEW_GUIDE_FIELDS = gql`
  fragment InterviewGuideFields on InterviewGuide {
    id
    title
    status
    archived
    author {
      id
      firstName
      lastName
    }
    division
    jobTitle
    interviewPurpose
    whenToUse
    includeChecklist
    includeCompetencies
    showSuggestions
    responseFormat
    questionsCount
    inputRequestedFrom {
      id
      firstName
      lastName
    }
    questions {
      id
      text
      scoringGuide {
        level1
        level2
        level3
        level4
        level5
      }
      order
      kssartiTopic
      locked
      savedToBank
      bankQuestionId
    }
    checklist {
      id
      text
      order
    }
    competencies {
      id
      name
      note
      order
    }
    generationStatus
    inUse
    createdAt
    updatedAt
  }
`;

export const SCORECARD_FIELDS = gql`
  fragment ScorecardFields on Scorecard {
    id
    interviewId
    user {
      id
      firstName
      lastName
    }
    guide {
      id
    }
    guideSnapshot {
      guideId
      title
      division
      jobTitle
      status
      includeCompetencies
      competencies {
        name
        note
      }
      includeChecklist
      checklist {
        text
      }
      questionCount
      showSuggestions
    }
    status
    questions {
      # No id: ScorecardQuestionEntry is a value type (embedded inline under the
      # Scorecard), so Apollo can't merge entries across scorecards. questionId
      # is the definition key the save/remove mutations address by.
      questionId
      questionText
      scoringGuide {
        level1
        level2
        level3
        level4
        level5
      }
      order
      score
      notes
      notAsked
      source
      kssartiTopic
      assessmentGapKey
    }
    recommendation
    finalComment
    guideScore
    candidateQuestionScore
    overallScore
    createdAt
    updatedAt
  }
`;
